import { intersection } from 'lodash';

import * as DNO from './dnoActions';
import * as MAZE from './mazeActions';
import * as CLPL from './clplApiActions';
import * as TRCO from './trcoActions';
import * as Vocab from './vocabActions';
import * as RAN from './ranActions';
import * as Spelling from './spellingActions';
import * as Dec from './decActions';
import * as lc from './lcActions';
import DNOServiceClient from '../clients/DNOServiceClient';
import MazeServiceClient from '../clients/MazeServiceClient';
import RANServiceClient from '../clients/RANServiceClient';
import DecServiceClient from '../clients/DecServiceClient';
import CLPLServiceClient from '../clients/CLPLServiceClient';
import selectors from '../../rootSelectors';
import {  SPELLING_SPA, SPELLING, VOCAB, VOCAB_SPA, TRO, LC } from '../../constants/measure';

export const RESULTS_FETCH_COMPLETED = 'RESULTS_FETCH_COMPLETED';
export const RESULTS_FETCH_RESET = 'RESULTS_FETCH_RESET';

export const resultsFetchCompleted = () => ({
    type: RESULTS_FETCH_COMPLETED,
});

export const resultsFetchReset = () => ({
    type: RESULTS_FETCH_RESET,
});

export const getStudentResults = () => (dispatch, getStore) => {
    const resultPromises = [];
    const activeMeasures = selectors.getActiveObsMeasures(getStore());

    if (intersection(activeMeasures, DNOServiceClient.MEASURES).length > 0) {
        resultPromises.push(dispatch(DNO.getStudentResults()));
    }
    if (intersection(activeMeasures, MazeServiceClient.MEASURES).length > 0) {
        resultPromises.push(dispatch(MAZE.getStudentResults()));
    }
    if (intersection(activeMeasures, CLPLServiceClient.MEASURES).length > 0) {
        resultPromises.push(dispatch(CLPL.getStudentResults()));
    }
    if (activeMeasures.includes(TRO.MEASURE)) {
        resultPromises.push(dispatch(TRCO.getStudentResults()));
    }
    if (activeMeasures.includes(LC.LISTEN_COMP)) {
        resultPromises.push(dispatch(lc.getStudentResults()));
    }
    if (intersection(activeMeasures, VOCAB.MEASURES.concat(VOCAB_SPA.MEASURES)).length > 0) {
        resultPromises.push(dispatch(Vocab.getStudentResults()));
    }
    if (intersection(activeMeasures, Object.keys(RANServiceClient.MEASURES)).length > 0) {
        resultPromises.push(dispatch(RAN.getStudentResults()));
    }
    if (intersection(activeMeasures, SPELLING.MEASURES.concat(SPELLING_SPA.MEASURES)).length > 0) {
        resultPromises.push(dispatch(Spelling.getStudentResults()));
    }
    if (intersection(activeMeasures, DecServiceClient.MEASURES).length > 0) {
        resultPromises.push(dispatch(Dec.fetchStudentResults()));
    }
    return Promise.all(resultPromises).then(() => {
        dispatch(resultsFetchCompleted());
    });
};
